if (!customElements.get('collection-hero-cta')) {
  customElements.define(
    'collection-hero-cta',
    class CollectionHeroCta extends HTMLElement {
      constructor() {
        super();
        this.targetId = '';
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.targetId = '';

        const link = this.querySelector('a[href]');

        if (!link) {
          this.remove();
          return;
        }

        let url;

        try {
          url = new URL(link.href, document.baseURI);
        } catch {
          this.remove();
          return;
        }

        const isSamePage = url.origin === window.location.origin &&
          url.pathname === window.location.pathname;

        if (!isSamePage) {
          this.hidden = false;
          return;
        }

        try {
          this.targetId = decodeURIComponent(url.hash.slice(1));
        } catch {
          this.remove();
          return;
        }

        if (!this.targetId || !document.getElementById(this.targetId)) {
          this.remove();
          return;
        }

        this.hidden = false;
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
        const target = document.getElementById(this.targetId);

        if (!link || !this.contains(link) || !target) return;

        event.preventDefault();

        const url = new URL(link.href, document.baseURI);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const productGridSection = target.closest('.shopify-section');
        const productControls = this.targetId === 'CollectionProductGrid'
          ? productGridSection?.querySelector('.filters-and-sort-main, #main-collection-filters')
          : null;
        const scrollTarget = productControls || target;
        const header = document.getElementById('shopify-section-header');
        const headerIsVisibleAndSticky = header?.classList.contains('shopify-section-header-sticky') &&
          !header.classList.contains('shopify-section-header-hidden');
        const headerOffset = headerIsVisibleAndSticky ? header.getBoundingClientRect().height : 0;
        const scrollTop = window.scrollY + scrollTarget.getBoundingClientRect().top - headerOffset - 16;

        if (window.location.hash !== url.hash) {
          window.history.pushState(
            {searchParams: url.search.slice(1)},
            '',
            `${url.pathname}${url.search}${url.hash}`
          );
        }

        window.scrollTo({
          top: Math.max(0, scrollTop),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    }
  );
}
